module.exports = __webpack_public_path__ + "src/assets/img/bg.92f527d3.png";